import {
	Component, ViewEncapsulation, OnInit, OnChanges, ChangeDetectorRef,
	Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { language } from 'curvy';
import { Task } from '@task-utils/types';
import { orders_translations } from './orders.trans';
import { User } from '@task-modules/users';
import { TaskRoutes } from '@task-utils/routes';

@Component({
	selector: 'task-change-order',
	encapsulation: ViewEncapsulation.None,
	templateUrl: 'change-order.component.html',
	styles: [`
		task-change-order {
			max-width: 600px;
		}

		task-change-order .field-grid {
			display: grid;
			grid-auto-flow: row;
			grid-template-columns: 1fr 1fr;
			grid-gap: 0 8px;
		}

		task-change-order knw-search-picker {
			display: contents;
		}

		@media only screen and (max-width: 600px) {
			task-change-order .field-grid {
				grid-template-columns: 1fr;
			}
		}

		task-change-order task-inventory-cards label {
			margin-left: 0!important;
			margin-right: 0!important;
		}
	`]
})
export class ChangeOrderComponent implements OnInit {
	@Input()
	order: Task.Order;

	@Output('result')
	result: EventEmitter<Task.Order> = new EventEmitter();

	investment_types = Task.Investment_Type;
	inventory_details: Task.OrderDetail[] = [];
	new_inventory: Task.KAM_Inventory[] = [];
	can_edit_inventory = false;
	existing_inventory_ids: number[] = [];
	order_flags: Task.LabelFlags[] = [];
	label_ids: number[] = [];


	ngOnInit() {
		this.init();

		this.order = {...this.order};

		const existing_inventories = this.order.order_details
			.filter(d => d.order_detail_type_id === Task.ORDER_DETAIL_TYPE.INVENTORY);

		this.new_inventory = existing_inventories.map(d => d.inventory_data);

		this.existing_inventory_ids = existing_inventories.map(d => d.inventory_id);

		this.load_order_flags();
	}

	async load_order_flags() {

		const res = await TaskRoutes.label_flags.api_label_flags_get_all(this.order.company_id);

		let order_label_ids: number[] = [];
		if (this.order.labels && this.order.labels.length > 0) {
			order_label_ids = this.order.labels.map(label => label.label_id);
		}

		if (res.data) {
			for (const flag of res.data) {
				if (flag.status_id === Task.LABEL_FLAG_STATUS.DELETED) {
					continue;
				}

				const should_show = flag.orders;
				if (!should_show) {
					continue;
				}

				const was_selected_on_order = order_label_ids.includes(flag.label_id);

				this.order_flags.push({
					...flag,
					selected: was_selected_on_order
				});

				if (was_selected_on_order && !this.label_ids.includes(flag.label_id!)) {
					this.label_ids.push(flag.label_id!);
				}
			}
		}
	}

	on_label_flag_change(flag: Task.LabelFlags) {
		if (flag.selected) {
			if (!this.label_ids.includes(flag.label_id)) {
				this.label_ids.push(flag.label_id);
			}
		} else {
			this.label_ids = this.label_ids.filter(id => id !== flag.label_id);
		}
	}


	create_inventory_detail(answer: Task.KAM_Inventory) {
        let empty = true;

        for (let key in answer) {
            let val = answer[key]
            if (val !== undefined && val !== null && val !== "") {
                empty = false;
                break;
            }
        }

        if (empty) {
            return null;
        }

        let detail: Partial<Task.OrderDetail> = {
            order_id: this.order.order_id,
            order_detail_type_id: Task.ORDER_DETAIL_TYPE.INVENTORY,
            description: answer.inventory_name,
            inventory_id: answer.inventory_id,
            inventory_no: answer.inventory_no,
            inventory_serial_no: answer.inventory_serial_no,
            inventory_name: answer.inventory_name,
            inventory_data: answer
        };

        return detail as Task.OrderDetail;
    }

	async init() {
		language.load_translations(orders_translations);

		this.can_edit_inventory = await User.currentTypeIs(
			Task.USER_TYPE.REGIONAL_MAINTENANCE_MANAGER,
			Task.USER_TYPE.SPECIALIST_1,
			Task.USER_TYPE.SPECIALIST_2,
			Task.USER_TYPE.ADMIN, Task.USER_TYPE.SYSTEM_ADMIN,
			Task.USER_TYPE.SECTOR_ADMIN,
		);

	}

	done() {
		this.order["whier_id"] = this.order.whier.whier_id;

		this.order.order_details = this.order.order_details.filter(
		d => d.order_detail_type_id !== Task.ORDER_DETAIL_TYPE.INVENTORY ||
			this.new_inventory.some(i => i.inventory_id === d.inventory_id)
		);

		for (let i of this.new_inventory) {
			if (this.existing_inventory_ids.includes(i.inventory_id)) {
				continue;
			}
            let detail = this.create_inventory_detail(i);
            if (detail) {
                this.order.order_details.push(detail);
            }
        }

		this.label_ids = this.order_flags.filter(f => f.selected).map(f => f.label_id);

		const modified_order = {
			...this.order,
			label_ids: this.label_ids
		};



		this.result.emit(modified_order);
	}

	cancel() {
		this.result.emit(null);
	}
}
